import createVueComponent from '../createVueComponent';

const ChevronLast = createVueComponent('ChevronLastIcon', [
  ['path', { d: 'm7 18 6-6-6-6', key: 'lwmzdw' }],
  ['path', { d: 'M17 6v12', key: '1o0aio' }],
]);

export default ChevronLast;
